import { render } from "./ProjectElectricComponent.vue?vue&type=template&id=5890bc69&scoped=true&ts=true"
import script from "./ProjectElectricComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectElectricComponent.vue?vue&type=script&lang=ts"

import "./ProjectElectricComponent.vue?vue&type=style&index=0&id=5890bc69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5890bc69"]])

export default __exports__